import { Navigate } from 'react-router-dom'
import { useAuth } from '../hooks/use-auth'
import { Loader2 } from 'lucide-react'
import type React from 'react'

export function AdminRoute({ children }: { children: React.ReactNode }) {
  const { isLoggedIn, isAdmin, adminChecked } = useAuth()

  if (!isLoggedIn) {
    return <Navigate to="/" replace />
  }

  if (!adminChecked) {
    return (
      <div className="h-screen flex items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-orange-500" />
      </div>
    )
  }

  if (!isAdmin) {
    return <Navigate to="/workspace" replace />
  }

  return <>{children}</>
}
